import { CargoHeaderAction } from './components/header';
import { CancelDialog, MainDialog } from './components/dialog';

import { CargoProvider } from './context';
import { useCargoAlerts, useCargo } from './hooks';

export function Cargo() {
  useCargoAlerts();
  return (
    <CargoProvider>
      <CargoContent />
    </CargoProvider>
  );
}

function CargoContent() {
  const {
    isEnabledHeaderBtn,
    isVisibleHeaderBtn,
    isOpenCancelOrderDialog,
  } = useCargo();
  return (
    <>
      <MainDialog />
      {isOpenCancelOrderDialog && <CancelDialog />}
      {isVisibleHeaderBtn && (
        <CargoHeaderAction isEnabled={isEnabledHeaderBtn} />
      )}
    </>
  );
}
